import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Nav, Navbar } from 'react-bootstrap';
import styled from 'styled-components';

import Brand from './Brand';
import CartLink from './CartLink';
import LoginRegisterLinks from './LoginRegisterLinks';
import NavLink from './NavLink';
import UserDropdown from './UserDropdown';

import useHeader from './useHeader';
import {
  NAVIGATION_MENU_ZINDEX,
  STR_GALLERY,
  STR_STORE,
  URL_COLOR_GENIE_PUBLIC,
  URL_GALLERY,
  URL_STORE,
} from '../../utils/constants';
import { trackMainMenuNavigateClick } from '../tracking/discovery.tracking';
import theme from '../../ui-library/theme';
import { Box } from '../../ui-library/layout';
import { showSidebar } from '../ui/ui.actions';
import HamburgerMenu from './HamburgerMenu';

const StyledNavbarCollapse = styled(Navbar.Collapse)`
  @media (max-width: 991px) {
    margin-left: 16px;
  }
`;

const StyledNavbarContainer = styled.div`
  background-color: transparent;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: ${NAVIGATION_MENU_ZINDEX};
`;

const StyledHamburgerContainer = styled.div`
  width: 48px;
  height: 18px;
  margin: 8px 0 0 48px;

  @media (max-width: 912px) {
    margin 8px 0 0 16px;
  }
`;
const StyledBrandContainer = styled.div`
  width: 127px;
  height: 37px;
`;
const StyledCartContainer = styled.div`
  margin: 8px 48px 0 0;
  width: 48px;
  height: 37px;

  @media (max-width: 912px) {
    margin 8px 34px 0 0;
  }
`;

const handleBlogLinkClick = () => {
  trackMainMenuNavigateClick('Blog');
};

const Header = () => {
  const user = useSelector((state) => state.auth);
  const { showHeader, showHamburgerLight, showBrandLight, showCartLight } =
    useHeader();
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(showSidebar());
  };

  if (!showHeader) return null;
  return (
    <StyledNavbarContainer>
      <Box
        justifyContent='space-between'
        alignItems='center'
        flexDirection='row'
      >
        <StyledHamburgerContainer onClick={handleClick}>
          <HamburgerMenu isDark={!showHamburgerLight} />
        </StyledHamburgerContainer>
        <StyledBrandContainer>
          <Brand isDark={!showBrandLight} />
        </StyledBrandContainer>
        <StyledCartContainer>
          <CartLink isDark={!showCartLight} />
        </StyledCartContainer>
      </Box>
    </StyledNavbarContainer>
  );

  return (
    <header id='header' style={{ backgroundColor: '#3f3c30' }}>
      <Navbar expand='lg' collapseOnSelect variant='dark'>
        <Container>
          <Brand />
          <Navbar.Toggle aria-controls='basic-navbar-nav' />
          <StyledNavbarCollapse id='basic-navbar-nav'>
            <Nav className='ml-auto'>
              <NavLink url={URL_STORE} title={STR_STORE} />
              <NavLink url={URL_GALLERY} title={STR_GALLERY} />
              <NavLink url={URL_COLOR_GENIE_PUBLIC} title='Color Genie' />
              <a
                href='https://blog.askokey.com'
                className='nav-link'
                onClick={handleBlogLinkClick}
                style={{ color: theme.colors.primary.main }}
              >
                Blog
              </a>
            </Nav>
            <Nav className='ml-auto'>
              {user ? <UserDropdown user={user} /> : <LoginRegisterLinks />}

              <CartLink />
            </Nav>
          </StyledNavbarCollapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
